import { Reveal } from "./Motion";
import { Users, Coffee, BookOpen, MessagesSquare } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function ParentSpace() {
  const { t } = useLang();
  const OFFERS = [
    { icon: Coffee, title: t("parents.cafes.title"), text: t("parents.cafes.text"), status: t("status.bientot") },
    { icon: Users, title: t("parents.ateliers.title"), text: t("parents.ateliers.text"), status: t("status.projet_futur") },
    { icon: MessagesSquare, title: t("parents.groupes.title"), text: t("parents.groupes.text"), status: t("status.projet_futur") },
    { icon: BookOpen, title: t("parents.ressources.title"), text: t("parents.ressources.text"), status: t("status.bientot") },
  ];

  return (
    <section id="familles" className="py-16 md:py-24 bg-muted/50" data-testid="parents-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-12 gap-8 md:gap-10 items-start">
          <div className="md:col-span-5">
            <Reveal>
              <div className="chip">{t("parents.chip")}</div>
              <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-[1.05]">
                {t("parents.title_1")} <span className="text-primary">{t("parents.title_parents")}</span>
              </h2>
              <p className="mt-5 text-lg text-foreground/80 leading-relaxed">{t("parents.subtitle")}</p>
              <p className="mt-4 text-sm text-foreground/60 leading-relaxed">{t("parents.note")}</p>
            </Reveal>
          </div>

          <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5" data-testid="parents-grid">
            {OFFERS.map((o, i) => (
              <Reveal key={o.title} delay={i * 0.06}>
                <div className="bg-white rounded-2xl p-5 md:p-6 border border-border h-full">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl grid place-items-center" style={{ backgroundColor: "#EFE7F3", color: "hsl(var(--plum))" }}>
                      <o.icon className="w-5 h-5" strokeWidth={2} />
                    </div>
                    <span className="text-[10px] uppercase tracking-widest font-bold px-2 py-1 rounded-full" style={{ backgroundColor: "#EFE7F3", color: "hsl(var(--plum))" }}>
                      {o.status}
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading text-lg leading-tight">{o.title}</h3>
                  <p className="mt-2 text-sm text-foreground/75 leading-relaxed">{o.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
